<template>
  <div class="o-lang-switcher">
    <div class="o-lang-switcher__title">{{ activeLang.text }}</div>
    <ul class="o-lang-switcher__list">
      <li
        v-for="lang in available"
        :key="lang.key"
        class="o-lang-switcher__list-lang"
        :class="{ 'is-active': lang.key === $i18n.locale }"
        @click="setLocale(lang.key)"
      >
        {{ lang.text }}
      </li>
    </ul>
  </div>
</template>

<script>
import { languages } from '@/assets/js/$/i18n'

export default {
  name: 'LanguageSwitcher',
  props: {
    mode: {
      type: String,
      default: 'dropdown'
    }
  },
  data() {
    return {
      available: languages.available.exact.map((exact, index) => {
        return {
          key: exact,
          text: languages.available.loose[index]
        }
      })
    }
  },
  methods: {
    setLocale(locale) {
      this.$store.commit('ui/setLocale', locale)
    }
  },
  computed: {
    activeLang() {
      return this.available.find(lang => lang.key === this.$i18n.locale)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$langSwitcher-title-padding: 0.6em 0 !default;
$langSwitcher-title-color: inherit !default;
$langSwitcher-title-hover-color: $brand-black !default;

$langSwitcher-dropdown-bg: white !default;
$langSwitcher-dropdown-lang-padding: 0.6em 0.8em !default;
$langSwitcher-dropdown-lang-font-size: $langSwitcher-title-font-size * 0.9 !default;
$langSwitcher-dropdown-lang-color: black !default;
$langSwitcher-dropdown-lang-hover-bg: $brand-primary !default;
$langSwitcher-dropdown-lang-hover-color: black !default;

$langSwitcher-md-dropdown-bg: transparent !default;
$langSwitcher-md-dropdown-lang-padding: 0.6em !default;
$langSwitcher-md-dropdown-lang-font-size: 18px !default;
$langSwitcher-md-dropdown-lang-color: inherit !default;
$langSwitcher-md-dropdown-lang-hover-bg: $langSwitcher-md-dropdown-bg;
$langSwitcher-md-dropdown-lang-hover-color: $langSwitcher-title-hover-color;

$langSwitcher-md-dropdown-lang-active-bg: $langSwitcher-md-dropdown-bg;
$langSwitcher-md-dropdown-lang-active-color: $brand-primary;

.o-lang-switcher {
  z-index: 3;
  position: relative;
  display: flex;
  align-items: center;
  cursor: default;

  &__title {
    display: flex;
    align-items: center;
    padding: $langSwitcher-title-padding;
    font-size: $langSwitcher-title-font-size;
    color: $langSwitcher-title-color;
    text-transform: uppercase;

    &::before {
      content: '';
      width: 12px;
      height: 12px;
      position: relative;
      margin-right: 6px;
      display: block;
      background-image: url('~@/assets/images/icons/dropdown-arrow-primary.svg');
      background-size: contain;
    }

    &:hover {
      color: $langSwitcher-title-hover-color;
    }
  }

  &__list {
    right: 0;
    top: 100%;
    margin: 0;
    padding: 0;
    position: absolute;
    list-style: none;
    font-size: 21px;
    background-color: $langSwitcher-dropdown-bg;
    display: none;

    li {
      padding: $langSwitcher-dropdown-lang-padding;
      font-size: $langSwitcher-dropdown-lang-font-size;
      color: $langSwitcher-dropdown-lang-color;
      text-align: center;
      text-transform: uppercase;
      line-height: 20px;
      cursor: pointer;

      &:hover {
        background-color: $langSwitcher-dropdown-lang-hover-bg;
        color: $langSwitcher-dropdown-lang-hover-color;
      }

      &.is-active {
        display: none;
      }
    }
  }

  &:hover {
    .o-lang-switcher__list {
      display: block;
    }
  }

  .md &,
  .sm &,
  .xs & {
    .o-lang-switcher__title {
      display: none;
    }

    .o-lang-switcher__list {
      display: flex;
      position: static;
      background-color: $langSwitcher-md-dropdown-bg;

      li {
        padding: $langSwitcher-md-dropdown-lang-padding;
        font-size: $langSwitcher-md-dropdown-lang-font-size;
        color: $langSwitcher-md-dropdown-lang-color;

        &:first-child {
          padding-left: 0;
        }

        &:hover {
          background-color: $langSwitcher-md-dropdown-lang-hover-bg;
          color: $langSwitcher-md-dropdown-lang-hover-color;
        }

        &.is-active {
          display: block;
          background-color: $langSwitcher-md-dropdown-lang-active-bg;
          font-weight: 600;
          color: $langSwitcher-md-dropdown-lang-active-color;
        }
      }
    }
  }
}
</style>
